module.exports = __webpack_public_path__ + "static/media/records.043f6065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/shifting/records.jpg
// module id = 127
// module chunks = 0